module.exports = __webpack_public_path__ + "static/gallery-10-3b59894fcea2bd51f650c3372f5eb60a.jpg";